// ! IMPORTANT DO NOT CHANGE THE ORDER OF IMPORTS
import ErrorView from "@/components/views/error.view";
import NotFound from "@/components/views/not-found.view";
import { dehydrate, hydrate } from "@tanstack/react-query";
import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { routerWithQueryClient } from "@tanstack/react-router-with-query";
import { routeTree } from "./routeTree.gen";
import { container } from "@/services/container/container.service";

export function createRouter() {
    const queryClient = container.queryClient;

    const router = createTanStackRouter({
        routeTree,
        context: container,
        defaultPreload: "intent",
        defaultErrorComponent: ErrorView,
        defaultNotFoundComponent: NotFound,
        dehydrate: () => ({ queryClientState: dehydrate(queryClient) }),
        hydrate: dehydrated => {
            hydrate(queryClient, dehydrated.queryClientState);
        },
        scrollRestoration: true,
    });

    return routerWithQueryClient(router, queryClient);
}

declare module "@tanstack/react-router" {
    interface Register {
        router: ReturnType<typeof createRouter>;
    }
}
